import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OfferStatusIdType } from '../../../screens/Dashboard/constants/StatusMap';
import { DashboardSearchFieldsForm } from '../../../screens/Dashboard/subpages/components/initial-values';
import { RunningContractStatusType } from '../../../screens/Dashboard/subpages/utils/searchedValues.types';

const initialState = {
  contractsNumbersAcceptedPage: [] as string[],
  subPageLabelStatusIds: undefined as unknown as OfferStatusIdType[] | undefined,
  selectedComparisonOfferIds: [] as string[],
  searchForm: {} as DashboardSearchFieldsForm,
  runningContractStatus: undefined as unknown as RunningContractStatusType | undefined,
};

export type DashboardState = typeof initialState;

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  selectors: {
    selectSubPageLabelStatusIds: (state: DashboardState) => state.subPageLabelStatusIds,
    selectRunningContractStatus: (state: DashboardState) => state.runningContractStatus,
    selectDashboardSearchFormWithSelections: (state: DashboardState) =>
      state.searchForm as DashboardSearchFieldsForm & {
        selectedCheckboxes?: string[];
        currentPage?: number;
      },
    selectSelectedComparisonOfferIds: (state: DashboardState) => state.selectedComparisonOfferIds,
  },
  reducers: {
    setContractsNumbersAcceptedPage(state, { payload }: PayloadAction<string[]>) {
      state.contractsNumbersAcceptedPage = payload;
    },
    setRunningContractStatus(state, { payload }: PayloadAction<RunningContractStatusType | undefined>) {
      state.runningContractStatus = payload;
    },
    setSubPageLabelStatusIds(state, { payload }: PayloadAction<OfferStatusIdType[] | undefined>) {
      state.subPageLabelStatusIds = payload;
    },
    setDashboardSearchFormWithSelections(
      state,
      {
        payload,
      }: PayloadAction<
        DashboardSearchFieldsForm & {
          selectedCheckboxes?: string[];
          currentPage?: number;
        }
      >
    ) {
      state.searchForm = payload;
    },
    setSelectedComparisonOfferIds(state, { payload }: PayloadAction<string[]>) {
      state.selectedComparisonOfferIds = payload;
    },
    clearSelectedComparisonOfferIds(state) {
      state.selectedComparisonOfferIds = [];
    },
    resetDashboardSearchForm(state) {
      state.searchForm = {} as DashboardSearchFieldsForm;
    },
  },
});

export const dashboardSelectors = dashboardSlice.selectors;

export const {
  setContractsNumbersAcceptedPage,
  setRunningContractStatus,
  setSubPageLabelStatusIds,
  setDashboardSearchFormWithSelections,
  resetDashboardSearchForm,
  clearSelectedComparisonOfferIds,
  setSelectedComparisonOfferIds,
} = dashboardSlice.actions;

export const dashboardReducer = dashboardSlice.reducer;
